// Use server readiness keys and the same configuration detail as the Materials
// page to distinguish absent records from explicitly inactive configurations.
export const missingConfiguration = (readiness, configuration, shipping = false) => {
    const ready = shipping ? readiness?.hasShippingProfiles : readiness?.hasPrices
    const missing = shipping ? readiness?.missingShippingProfiles : readiness?.missingPrices
    if (typeof ready !== 'boolean' || !Array.isArray(missing)) return null
    if (ready) return { absent: 0, inactive: 0 }
    const records = shipping ? configuration?.shippingProfiles : configuration?.prices
    if (!Array.isArray(records)) return null
    const inactive = missing.filter(key => records.some(row => row.isActive === false &&
        (shipping ? row.size === key.size && row.marialuisaMode === key.marialuisaMode : row.size === key))).length
    return { absent: missing.length - inactive, inactive }
}

export const pendingConfiguration = (material, configuration) => {
    const prices = missingConfiguration(material.readiness, configuration)
    const shipping = missingConfiguration(material.readiness, configuration, true)
    if (!prices || !shipping) return null
    return prices.absent + shipping.absent > 0
}
